import { Grid, IconButton, TextField, Autocomplete, Card } from "@mui/material";
import { Exercise, WorkoutDayExercise } from "../../../../service/model/workout.model";
import { DeleteIcon } from "../../../../shared/icons";

interface ExerciseRowProps {
    exercise: WorkoutDayExercise;
    exercises: Exercise[];
    onExerciseChange?: (exercise: Exercise) => void;
    onSetsChange?: (sets: number) => void;
    onRepsChange?: (reps: number) => void;
    onTargetWeightChange?: (targetWeight: number) => void;
    onRestSecondsChange?: (restSeconds: number) => void;
    onTargetDurationChange?: (targetDuration: number) => void;
    onDelete?: () => void;
}

const ExerciseRow: React.FC<ExerciseRowProps> = ({ exercise, exercises, onExerciseChange, onSetsChange, onRepsChange, onTargetWeightChange, onRestSecondsChange, onTargetDurationChange, onDelete }) => {
    return (
        <Card variant="outlined" sx={{ p: 2, mb: 2, width: '100%', borderRadius: 2 }}>
            <Grid container alignItems="center" spacing={1} sx={{ mb: { xs: 4, md: 1 } }}>
                <Grid container size={{ xs: 10 }}>
                    <Grid size={{ xs: 12, md: 3 }}>
                        <Autocomplete
                            options={exercises}
                            size="small"
                            value={exercises.find((item) => item.id === exercise.exercise?.id) || null}
                            onChange={(event, newValue) => {
                                if (newValue) {
                                    onExerciseChange?.(newValue);
                                }
                            }}
                            getOptionLabel={(option: any) => option?.name ?? ''}
                            isOptionEqualToValue={(option: any, value: any) => option?.id === value?.id}
                            renderInput={(params) => <TextField {...params} label="Exercise" variant="standard" />}
                        />
                    </Grid>
                    <Grid size={{ xs: 3, md: 2 }}>
                        <TextField
                            type="number"
                            size="small"
                            label="Sets"
                            variant="standard"
                            value={exercise.sets}
                            disabled={!exercise.exercise?.id} // Disable sets input until a exercise is selected
                            onChange={(e) => {
                                const newSets = Number(e.target.value);
                                if (!isNaN(newSets)) {
                                    onSetsChange?.(newSets);
                                }
                            }}
                        />
                    </Grid>
                    <Grid size={{ xs: 3, md: 2 }}>
                        <TextField
                            type="number"
                            size="small"
                            label="Reps"
                            variant="standard"
                            value={exercise.reps}
                            disabled={!exercise.exercise?.id} // Disable reps input until a exercise is selected
                            onChange={(e) => {
                                const newReps = Number(e.target.value);
                                if (!isNaN(newReps)) {
                                    onRepsChange?.(newReps);
                                }
                            }}
                        />
                    </Grid>
                    <Grid size={{ xs: 3, md: 2 }}>
                        <TextField
                            type="number"
                            size="small"
                            label="Weight (kg)"
                            variant="standard"
                            value={exercise.targetWeight}
                            disabled={!exercise.exercise?.id} // Disable target weight input until a exercise is selected
                            onChange={(e) => {
                                const newTargetWeight = Number(e.target.value);
                                if (!isNaN(newTargetWeight)) {
                                    onTargetWeightChange?.(newTargetWeight);
                                }
                            }}
                        />
                    </Grid>
                    <Grid size={{ xs: 3, md: 2 }}>

                        <TextField
                            type="number"
                            size="small"
                            label="Duration (min)"
                            variant="standard"
                            value={exercise.targetDuration}
                            disabled={!exercise.exercise?.id} // Disable target duration input until a exercise is selected
                            onChange={(e) => {
                                const newTargetDuration = Number(e.target.value);
                                if (!isNaN(newTargetDuration)) {
                                    onTargetDurationChange?.(newTargetDuration);
                                }
                            }}
                        />
                    </Grid>
                    {/*<Grid size={{ xs: 2 }}>
                <TextField
                    type="number"
                    size="small"
                    label="Rest Time"
                    variant="standard"
                    value={exercise.restSeconds}
                    disabled={!exercise.exercise?.id} // Disable rest time input until a exercise is selected
                    onChange={(e) => {
                        const newRestTime = Number(e.target.value);
                        if (!isNaN(newRestTime)) {
                            onRestSecondsChange?.(newRestTime);
                        }
                    }}
                />
            </Grid> */}
                </Grid>
                <Grid size={{ xs: 1 }}>
                    <IconButton aria-label="delete exercise" title="Delete exercise" onClick={onDelete} color="error">
                        <DeleteIcon />
                    </IconButton>
                </Grid>
            </Grid>
        </Card>
    );
};

export default ExerciseRow;
